import { models } from 'powerbi-client';

export const USER_ROLE = {
    SYSTEM_ADMIN: 1,
    CLIENT_ADMIN: 2,
    USER: 3,
};

export const USER_ROLE_VALUES = {
    3: 'User',
    2: 'Client Admin',
    1: 'System Admin'
}

export const LOCAL_STORAGE_KEY = {
    CURRENT_USER: 'CURRENT_USER',
};

export const reportLayoutSettings = {
    layoutType: models.LayoutType.Master,
    customLayout: {
        pageSize: {
            type: models.PageSizeType.Custom,
        },
        displayOption: models.DisplayOption.FitToPage,
        pagesLayout: {
            ReportSection1: {
                defaultLayout: {
                    displayState: {
                        mode: models.VisualContainerDisplayMode.Hidden,
                    },
                },
                visualsLayout: {
                    VisualContainer1: {
                        x: 1,
                        y: 1,
                        z: 1,
                        displayState: {
                            mode: models.VisualContainerDisplayMode.Visible,
                        },
                    },
                    VisualContainer2: {
                        displayState: {
                            mode: models.VisualContainerDisplayMode.Visible,
                        },
                    },
                },
            },
        },
    },
};

export const POWER_BI_REPORTS = {
    STAR_REPORT_CARD: 'Star Report Card',
    STARS_DATA_EXPLORER: 'Stars Data Explorer',
    POPULATION_CHARECTERIZATIONS: 'Population Characterizations'
};

export const USER_STATUS = {
    O: 'Operational',
    P: 'Permanent',
    A: 'Archived',
}

export const USER_STATUS_VALUE = {
    Operational: 'O',
    Permanent: 'P',
    Archived: 'A',
}

export const COMPANY_STATUS_VALUE = {
    Operational: 'O',
    Permanent: 'P',
    Archived: 'A',
}

export const DEFAULT_PAGE = "Home";

export const COHORT_FILE_STATUS = {
    UPLOADED: 'Uploaded',
    VALIDATED: 'Validated',
    ENRICHED: 'Enriched',
    SCHEDULE: 'Scheduled',
    ERROR: 'Error',
    ARCHIVED: 'Archived',
};

export const RETENTION_MANAGEMENT_MEMBER_STATUS = {
    VALIDATED: 'V',
    VALIDATION_ERROR: 'VE',
    MATCHED: 'M',
    MATCHED_ERROR: 'ME',
    PROCESSED: 'P',
    REMOVED: 'R',
    EXCLUDED: 'X',
    UNENROLLED: 'U',
    COHORT_UPDATE: 'CU',
};

export const RETENTION_MANAGEMENT_MEMBER_STATUS_VALUE = {
    V: 'Validated',
    VE: 'Validation Error',
    M: 'Matched',
    ME: 'Matched Error',
    P: 'Processed',
    R: 'Removed',
    X: 'Excluded',
    NC: 'No Contact',
    U: 'Unenrolled',
    CU: 'Cohort Update',
}

// CE - Cohort Exception
// is added as it's not present in cohort member status value options
// and only available in cohort member update input status options
export const COHORT_DELTA_MEMBER_STATUS_VALUES = {
    ...RETENTION_MANAGEMENT_MEMBER_STATUS_VALUE,
    CE: 'Exception',
}

export const COHORT_TRAINING_FLAG = {
    Y: 'Yes',
    N: 'No',
};

export const COHORT_MARKET_TYPE = {
    Single: 'Single',
    Multiple: 'Multiple',
};

export const AUDIENCE_USER_ROLE = {
    A: 'All', // default
    U: 'User',
    Z: 'Admin',
}

export const AUDIENCE_APPLICATION = {
    A: 'All', // default
    G: 'Advisory Group',
    M: 'Member Analytics',
    Q: 'Quality Management',
    Z: 'Admin Center',
}

export const CONTENT_APPLICATION = {
    ALL: 'A',
    ADVISORY_GROUP: 'G',
    MEMBER_ANALYTICS: 'M',
    QUALITY_MANAGEMENT: 'Q',
    ADMIN: 'Z',
}

export const AUDIENCE_APPLICATION_STATUS = {
    ADVISORY_GROUP: 'G',
    MEMBER_ANALYTICS: 'M',
    QUALITY_MANAGEMENT: 'Q',
    ADMIN: 'A',
    SYSTEM: 'S'
}

export const AUDIENCE_SEGMENT = {
    A: 'All', // default
    H: 'Provider',
    P: 'Plan',
}

export const CMS_CONTENT_TYPE = {
    B: 'Blog',
    N: 'News',
    G: 'Graph of Month',
    A: 'Product Announcement',
    T: 'Product Tip',
}

export const CONTENT_TYPE = {
    Blog: 'B',
    News: 'N',
    GraphOfMonth: 'G',
    ProductAnnouncement: 'A',
    ProductTip: 'T'
}

export const CMS_CONTENT_FORMAT = {
    P: 'PDF',
    J: 'JPEG',
    H: 'HTML',
}

export const MIME_TYPES = {
    JPG: 'image/jpeg',
    JPEG: 'image/jpeg',
    JFIF: 'image/jpeg',
    PNG: 'image/png',
    SVG: 'image/svg+xml',
    GIF: 'image/gif',
    PDF: 'application/pdf',
    HTML: 'text/html',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    CSV: 'text/csv',
}

export const DOCUMENT_FORMAT = {
    P: 'PDF',
    J: 'JPEG',
    W: 'DOCX',
    S: 'PPTX',
    X: 'XLSX',
}

export const DOCUMENT_FORMAT_ABBR = {
    PDF: 'P',
    JPEG: 'J',
    DOCX: 'W',
    PPTX: 'S',
    XLSX: 'X',
}

export const RECORD_STATUS = {
    O: 'Operational',
    A: 'Archived'
}

export const RECORD_STATUS_ABBR = {
    Operational: 'O',
    Archived: 'A'
}


export const CONTENT_RECORD_STATUS = {
    Operational: 'O',
    Archived: 'A',
    Permanent: 'P'
}

export const NOTIFICATION_RECORD_STATUS = {
    OPEN: 'O',
    ARCHIVED: 'A'
}

export const POSITIONS = {
    TOP: 'top',
    BOTTOM: 'bottom',
    NONE: 'none',
}

export const ALIGN = {
    LEFT: 'start',
    RIGHT: 'end',
}

export const LANGUAGE_TYPE = {
    English: 'English',
    Spanish: 'Spanish',
    Chinese: 'Chinese',
    Korean: 'Korean',
    Russian: 'Russian',
    Vietnamese: 'Vietnamese',
    Other: 'Other'
}

export const PROGRAM_TYPE = {
    O: 'Other',
    E: 'EAC',
}

export const PROGRAM_TYPE_ABBR = {
    Other: 'O',
    EAC: 'E',
}

export const AGGREGATE_SCORES = {
    N: 'Non Representative',
    M: 'Minimally Representative',
    P: 'Partially Representative',
    C: 'Representative'
}

export const AGGREGATE_SCORES_LABELS = [
    AGGREGATE_SCORES.N,
    AGGREGATE_SCORES.M,
    AGGREGATE_SCORES.P,
    AGGREGATE_SCORES.C,
];

export const SCORE_RATING = {
    Compliant_Representative: 'C',
    MinimallyCompliant_Representative: 'M',
    PartiallyCompliant_Representative: 'P',
    NonCompliant_Representative: 'N'
}

export const AGGREGATE_SCORES_OTHER = {
    N: 'Non Representative',
    M: 'Minimally Representative',
    P: 'Partially Representative',
    C: 'Representative'
}

export const REPSCORE_CATEGORIES_DEMOGRAPHIC = {
    Age: 'Age',
    Language: 'Language',
    Gender: 'Gender',
    Ethnicity: 'Ethnicity',
    Race: 'Race',
    UrbanRural: 'Urban-Rural',
    TechnologyScore: 'Technology Score',
    HealthAccess: 'Health Access',
}

export const REPSCORE_CATEGORIES_GEOGRAPHIC = {
    County: 'County',
    Region: 'Region',
}

export const AGGREGATE_SCORES_COLOR = {
    N: 'bg-red',
    M: 'bg-orange',
    P: 'bg-yellow',
    C: 'bg-green'
}

export const PROGRAM_STATUS = {
    New: 'New',
    Active: 'Active',
    Archived: 'Archived',
}

export const AG_STATUS = {
    New: 'New',
    Active: 'Active',
    Archived: 'Archived',
}

export const US_STATE = {
    AL: 'AL', AK: 'AK', AZ: 'AZ', AR: 'AR', CA: 'CA', CO: 'CO', CT: 'CT', DE: 'DE',
    FL: 'FL', GA: 'GA', HI: 'HI', ID: 'ID', IL: 'IL', IN: 'IN', IA: 'IA', KS: 'KS', KY: 'KY',
    LA: 'LA', ME: 'ME', MD: 'MD', MA: 'MA', MI: 'MI', MN: 'MN', MS: 'MS', MO: 'MO', MT: 'MT',
    NE: 'NE', NV: 'NV', NH: 'NH', NJ: 'NJ', NM: 'NM', NY: 'NY', NC: 'NC', ND: 'ND', OH: 'OH',
    OK: 'OK', OR: 'OR', PA: 'PA', RI: 'RI', SC: 'SC', SD: 'SD', TN: 'TN', TX: 'TX', UT: 'UT',
    VT: 'VT', VA: 'VA', WA: 'WA', WV: 'WV', WI: 'WI', WY: 'WY'
}

export const PROGRAM_MEETING_FREQUENCY = {
    M: 'Monthly',
    B: 'Bimonthly',
    Q: 'Quarterly',
    S: 'Biannual',
    O: 'Other'
}

export const PROGRAM_MEETING_TYPE = {
    I: 'In person',
    H: 'Hybrid',
    V: 'Virtual'
}

export const AG_RECRUITMENT_MEMBER_STATUS = {
    Applied: 'Applied',
    Interest: 'Interest',
    Selected: 'Selected',
    Hold: 'Hold',
    Enrolled: 'Enrolled',
    Decline: 'Decline',
    Retired: 'Retired',
    Expired: 'Expired',
    Error: 'Error',
    Augmented: 'Augmented',
    Archive: 'Archive'
};

export const SUPPORT_STAFF_MEMBER_STATUS = {
    Operational: 'O',
    Archived: 'A'
}

export const AG_RECRUITMENT_APPLICATION_STATUS_VALUE = {
    Open: 'Open',
    Matched: 'Matched',
    Invalid: 'Invalid',
    Error: 'Error',
    Archive: 'Archive',
    New: 'New'
}

export const AG_NON_MEMBER_STATUS = {
    Enrolled: 'Enrolled',
    Retired: 'Retired',
    Error: 'Error',
}

export const MEETING_STATUS = {
    P: 'Planned',
    S: 'Scheduled',
    C: 'Completed'
}

export const AG_MEETING_STATUS = {
    P: 'Planned',
    S: 'Scheduled',
    C: 'Completed',
    D: 'Documented',
    A: 'Archive',
    X: 'Cancelled'
}

export const AG_REPSCORE_TYPE = {
    Panel: 'P',
    Baseline: 'B',
    Attendance: 'A'
}

export const AG_REPSCORE_TYPE_VALUE = {
    P: 'Panel Score',
    B: 'Baseline',
    A: 'Attendance Score'
}

export const AG_REPSCORE_COLUMN_HEADER_PREFIX = {
    P: 'Panel',
    A: 'Participation'
}

export const AG_MEETING_STATUS_INVERSE = {
    Planned: 'P',
    Scheduled: 'S',
    Completed: 'C',
    Documented: 'D',
    Archive: 'A',
    Cancelled: 'X'
};


export const AG_MEETING_ATTENDANCE_STATUS_PRE = {
    N: 'No Response',
    C: 'Confirmed',
    D: 'Declined',
    M: 'Maybe'
}

export const AG_MEETING_ATTENDANCE_STATUS_PRE_INVERSE = {
    NoResponse: 'N',
    Confirmed: 'C',
    Declined: 'D',
    Maybe: 'M'
}

export const AG_MEETING_ATTENDANCE_STATUS_POST = {
    NA: 'Future Meeting',
    X: 'Cancelled',
    A: 'Attended',
    M: 'No show',
    D: 'Declined / No Response',
    U: 'Unplanned'
}

export const AG_MEETING_ATTENDANCE_STATUS_POST_INVERSE = {
    FutureMeeting: 'NA',
    Cancelled: 'X',
    Attended: 'A',
    NoShow: 'M',
    Declined: 'D',
    Unplanned: 'U'
}

export const AG_MEETING_NON_MEMBER_ATTENDANCE_STATUS_PRE = {
    NoResponse: 'N',
    Confirmed: 'C',
    Declined: 'D',
    Maybe: 'M'
}

export const AG_MEETING_NON_MEMBER_ATTENDANCE_STATUS_PRE_VALUE = {
    N: 'No Response',
    C: 'Confirmed',
    D: 'Declined',
    M: 'Maybe'
}

export const AG_MEETING_NON_MEMBER_ATTENDANCE_STATUS_POST = {
    Cancelled: 'X',
    Attended: 'A',
    NoShow: 'N',
    NA: 'NA',
}

export const AG_MEETING_NON_MEMBER_ATTENDANCE_STATUS_POST_VALUE = {
    X: 'Cancelled',
    A: 'Attended',
    N: 'No show',
    NA: 'NA',
}

export const AG_MEETING_SUPPORT_STAFF_ATTENDANCE_STATUS = {
    Assigned: 'A',
    Confirmed: 'C',
    Cancelled: 'X',
}

export const AG_MEETING_SUPPORT_STAFF_ATTENDANCE_STATUS_VALUE = {
    A: 'Assigned',
    C: 'Confirmed',
    X: 'Cancelled',
}

export const AG_MEETING_SUPPORT_STAFF_ATTENDANCE_STATUS_POST = {
    NA: 'NA',
    Cancelled: 'X',
    Attended: 'A',
    NoShow: 'NS',
}

export const AG_MEETING_SUPPORT_STAFF_ATTENDANCE_STATUS_POST_VALUE = {
    NA: 'NA',
    X: 'Cancelled',
    A: 'Attended',
    NS: 'No Show',
}

export const AG_MEETING_SUPPORT_STAFF_RECORD_STATUS = {
    Operational: 'O',
    Cancelled: 'X',
}

export const YES_NO = {
    Y: 'Yes',
    N: 'No'
}

export const YES_NO_INVERSE = {
    Yes: 'Y',
    No: 'N'
}

export const FORM_ACTION_TYPE = {
    New: 'New',
    Edit: 'Edit',
    View: 'View',
    Copy: 'Copy'
}

export const NOIFICATION_TYPE = {
    A: 'Alert',
    E: 'Error',
    P: 'Process',
    M: 'Informational Management',
    S: 'System'
}

export const NOIFICATION_APPLICATION = {
    A: 'Admin',
    M: 'Member Analytics',
    G: 'Advisory Group Management',
    Q: 'Quality Management',
    S: 'System'
}

export const NOTIFICATION_SOURCE = {
    ...NOIFICATION_APPLICATION
}

export const NOTIFICATION_STATUS_VALUE = {
    Archive: 'A',
    Open: 'O',
    Read: 'R'
}

export const EXPORT_RETENTION_RISK_FORMAT = {
    P: 'pdf',
    X: 'xls',
    C: 'csv',
}

export const COHORT_RETENTION_RISK_STATUS = {
    Requested: 'R',
    Scored: 'S',
    Error: 'E',
    Empty: ''
}

export const COHORT_RETENTION_RISK_STATUS_VALUE = {
    R: 'Requested',
    S: 'Scored',
    E: 'Error',
}

export const SUBMIT_ACTION = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export const ALERT_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export const MESSAGE_LISTEN_TYPE = {
    SCHEDULE_COHORT: 'SCHEDULE_COHORT',
    PROCESSED_COHORT_FILE: 'PROCESSED_COHORT_FILE',
}

export const PARKING_STATUS = {
    F: 'Free',
    M: 'Master',
    V: 'Validated',
    U: 'Unknown'
}

export const COHORT_STATUS = {
    UPLOADED: 'Uploaded',
    VALIDATED: 'Validated',
    ENRICHED: 'Enriched',
    SCHEDULED: 'Scheduled',
    ERROR: 'Error',
    ARCHIVED: 'Archived',
};

export const RATINGS = {
    FC: 'Fully Representative',
    CC: 'Representative',
    SC: 'Somewhat Representative',
    MC: 'Minimally Representative',
    NC: 'Not Representative',
    XC: 'Significantly Not Representative',
}

export const EAC_PHONE_TYPE = {
    Mobile: 'Mobile',
    Landline: 'Landline'
}

export const EAC_RELATIONSHIPS = {
    Spouse: 'Spouse/Partner',
    Daughter: 'Daughter',
    Son: 'Son',
    Brother: 'Brother',
    Sister: 'Sister',
    Friend: 'Friend',
    Other: 'Other',
}

export const VALIDATIONS = {
    Number: {
        isInteger: {
            test: /(?<![.+])^-?\d+$(?!.)/,
            msg: 'Value must be an integer'
        },
        isPositiveInteger: {
            test: /^[1-9]\d*$/,
            msg: 'Value must be a positive non-zero integer'
        },
        isId: {
            test: /^-?[1-9]\d*$/,
            msg: 'Value must be a non-zero integer'
        },
        isZipCode: { // US zipcode
            test: /^\d{5}(?:\d{4})?$/,
            msg: 'Zip code must be either 5 or 9 digits'
        },
        isPhone: { // US phone number
            // test: /^[1-9]\d{9}$/, // Regex for phone number without hyphen, brackets or dot
            // test: /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, // Regex for phone number with hyphen '-', brackets '()' or dot '.'
            test: /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, // Regex for phone number with hyphen '-'
            msg: 'Phone number is invalid'
        }
    },
    String: {
        noSpecialChars: {
            // either singe or double quote allowed, no mismatched quotes, no quotes at beginning or end and not allowed with brackets
            test: /^(?!['"])(?!.*['"]$)(?!.*\(["'].*\))(?!.*\(.*['"].*\))[A-Za-z0-9 ?!,:;().'"_\/\-]+$/,
            msg: 'Sorry, the only special characters allowed are: \? \! \, \: \; \( \) \. \' \" \_ \- \/'
        },
        isTitle: {
            test: /^[A-Za-z0-9 ,:._-]*$/,
            msg: 'Field should only have letters, numbers and allowed punctuation \, \: \. \_ \-'
        },
        isName: {
            test: /^[A-Za-z]+( [A-Za-z]+)*$/,
            msg: 'Remove any leading or trailing spaces.'
        },
        isURL: {
            test: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[\w\-./?%&= ]*)?(?:#[\w]*)?$/,
            msg: 'Invalid URL. Please enter a valid URL.'
        }
    }
}

export const VALUE = {
    Min: 'min',
    Max: 'max',
}

export const NAVIGATION_BOX_TYPE = {
    LINK: 'Link',
    MODAL: 'Modal'
}

export const MEMBER_OUTCOME_STATUS_VALUE = {
    A: 'Acceptance',
    N: 'Not Available',
    D: 'Declined',
    O: 'Other'
};

export const ONBOARDING_STATUS = {
    Pending: 'Pending',
    Complete: 'Complete',
};

export const MEMBER_OUTCOME_STATUS = {
    Acceptance: 'A',
    Not_Available: 'N',
    Other: 'O',
    Declined: 'D'
};

export const EMPTY_OPTION = {
    '': 'Select'
}

export const MAX_VALUE = {
    INT: 2147483647,
}

export const AG_MEMBER_STATUS = {
    Temporary: 'Temp',
    New: 'New',
    Removed: 'Removed',
    MoveBackToPotential: 'MoveBackToPotential'
}

export const APPLICATION_SUBMISSION_TYPE = {
    PHARO_USER: 'P',
    EXTERNAL_USER: 'E'
}

export const REVISED_SCORE_TYPE = {
    PanelScore: 'P',
    BaseScore: 'B',
    AttendanceScore: 'A'
}

export const SUPPORT_STAFF_ROLE = {
    Client: 'Client',
    Community: 'Community',
    Consultant: 'Consultant'
};

export const CARE_GIVER_MEMBER_STATUS = {
    Operational: 'O',
    Archived: 'A'
}

export const TIMEZONES = {
    E: 'US/Eastern',
    C: 'US/Central',
    M: 'US/Mountain',
    P: 'US/Pacific'
}

export const TIMEZONE_ABBR = {
    Eastern: 'E',
    Central: 'C',
    Mountain: 'M',
    Pacific: 'P'
}

export const TRANSPORTATION_MODE = {
    D: 'Drive',
    A: 'Arranged',
    P: 'Public',
    O: 'Other'
}

export const AG_MEETING_ATTENDANCE_LINK_TYPE = {
    Member: 'M',
    NonMember: 'N',
    SupportStaff: 'S'
}

export const APP_ICONS = {
    advisoryGroupManagement: 'advisory-group-management',
    memberAnalytics: 'member-analytics',
    qualityManagement: 'quality-management',
    planDesign: 'plan-design-and-fit',
    marketAssessment: 'market-assment',
}

export const SUBSCRIPTION = {
    advisoryGroupManagement: 'subscriptionAGM',
    memberAnalytics: 'subscriptionMM',
    qualityManagement: 'subscriptionQM',
    planDesign: 'subscriptionPD',
    marketAssessment: 'subscriptionMF',
}

export const SUBSCRIPTION_LABEL = {
    advisoryGroupManagement: 'Advisory Group Management',
    memberAnalytics: 'Member Management',
    qualityManagement: 'Quality Management',
    planDesign: 'Plan Design and Fit',
    marketAssessment: 'Market Assessment',
}

export const APPLICATION_SUBSCRIPTION = {
    Subscribed: 'S',
    NotSubscribed: 'N'
}

export const PROXY_FLAG = {
    Proxy: 'P',
    Guardian: 'G'
}

export const HELP_SCREENS = {
    main: 'main',
    screenHelp: 'screen-help',
    faqs: 'faqs',
    support: 'support',
    whatsNew: 'updates',
    version: 'version'
}

export const HELP_SCREENS_TITLE = {
    main: 'Help',
    screenHelp: 'Screen Help',
    faqs: 'Frequency Asked Questions',
    support: 'Contact Support',
    whatsNew: 'What\'s New',
    version: 'Version Information'
}

export const FILE_TYPE = {
    Local: 'L',
    System: 'S'
}

export const FILE_TYPE_VALUE = {
    L: 'Local File',
    S: 'System File'
}

export const COHORT_UPDATE_RECORD_STATUS = {
    Add: 'Add',
    Input: 'Input',
    Exception: 'Exception',
    UnEnrolled: 'UnEnrolled'
}

export const COHORT_UPDATE_STATUS = {
    InProcess: 'InProcess',
    Error: 'Error',
    Processed: 'Processed',
    Archived: 'Archived',
    Validated: 'Validated',
    Uploaded: 'Uploaded'
}

export const BLOCKER_STATES = {
    Blocked: 'blocked',
    Unblocked: 'unblocked',
    Proceeding: 'proceeding'
}

export const MEMBER_FILE_TYPE = {
    COHORT: 'C',
    COHORT_UPDATE: 'CU',
}

export const NON_MEMBER_RETIREMENT_REASONS = [
    "Graduated",
    "Panel Term Ended",
    "Requested Removal"
];

export const MEMBER_ACCOMODATION_NEEDS = {
    Cane: 'Cane',
    HearingImpaired: 'Hearing Impaired',
    Scooter: 'Scooter',
    Walker: 'Walker',
    Wheelchair: 'Wheelchair',
    Other: 'Other',
};
